// PostHog in the browser — ERROR TRACKING ONLY.
// Usage events (DAU, ingest, search) are captured server-side; here we only
// want uncaught errors + unhandled promise rejections, attributed to the
// signed-in user. Everything that could record note content (autocapture,
// session replay, heatmaps) is off. No-op when REACT_APP_POSTHOG_KEY is unset.
import posthog from 'posthog-js';

const KEY = process.env.REACT_APP_POSTHOG_KEY;
const HOST = process.env.REACT_APP_POSTHOG_HOST || 'https://us.i.posthog.com';

export const analyticsEnabled = Boolean(KEY);

if (analyticsEnabled) {
  posthog.init(KEY, {
    api_host: HOST,
    capture_exceptions: true,
    autocapture: false,
    capture_pageview: false,
    capture_pageleave: false,
    capture_dead_clicks: false,
    capture_heatmaps: false,
    capture_performance: false,
    rageclick: false,
    disable_session_recording: true,
    disable_surveys: true,
    disable_web_experiments: true,
    disable_product_tours: true,
    disable_conversations: true,
    advanced_disable_flags: true,
    person_profiles: 'identified_only',
  });
}

// Same distinct_id as the backend (Cognito sub), so web errors land on the
// same person as their server-side events.
export function identifyUser(user) {
  if (!analyticsEnabled) return;
  if (user?.sub) {
    posthog.identify(user.sub, { email: user.email, name: user.name });
  } else {
    posthog.reset();
  }
}
